import {Injectable} from '@angular/core';
import {NgbDateParserFormatter, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import 'moment-timezone';

function padNumber(value: number) {
    if (isNumber(value)) {
        return `0${value}`.slice(-2);
    } else {
        return '';
    }
}

function isNumber(value: any): boolean {
    return !isNaN(toInteger(value));
}

function toInteger(value: any): number {
    return parseInt(`${value}`, 10);
}

@Injectable()
export class MyDateFRParserFormatter implements NgbDateParserFormatter {
    parse(value: string): NgbDateStruct {
        // if (value) {
        //     const dateParts = value.trim().split('/');
        //     if (dateParts.length === 1 && isNumber(dateParts[0])) {
        //         return {year: toInteger(dateParts[0]), month: null, day: null};
        //     } else if (dateParts.length === 2 && isNumber(dateParts[0]) && isNumber(dateParts[1])) {
        //         return {year: toInteger(dateParts[1]), month: toInteger(dateParts[0]), day: null};
        //     } else if (dateParts.length === 3 && isNumber(dateParts[0]) && isNumber(dateParts[1]) && isNumber(dateParts[2])) {
        //         return {year: toInteger(dateParts[2]), month: toInteger(dateParts[1]), day: toInteger(dateParts[0])};
        //     }
        // }
        if (value) {
            console.log(value);
            const date = moment(value, 'YYYY MMM DD', true);
            if (date.isValid()) {
                console.log({
                    year: toInteger(date.format('YYYY')),
                    month: toInteger(date.format('MM')),
                    day: toInteger(date.format('DD')),
                });
                return {
                    year: toInteger(date.format('YYYY')),
                    month: toInteger(date.format('MM')),
                    day: toInteger(date.format('DD')),
                };
            }
        }
        return null;
    }

    format(date: NgbDateStruct): string {
        let stringDate: string = '';
        if (date) {
            // stringDate += isNumber(date.day) ? padNumber(date.day) + "/" : "";
            // stringDate += isNumber(date.month) ? padNumber(date.month) + "/" : "";
            // stringDate += date.year;
            stringDate = moment([date.year, date.month - 1, date.day]).format('YYYY MMM DD');
        }
        return stringDate;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/ngbdateparsers/my-date-parser-formatter/my-date-parser-formatter.ts